import apiClient from "../common/apiClient";

export default class DoctorDepartmentController {
    async Create(data, token) {
        try {
            return await apiClient.post("/doctor-department", data, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async Update(id, data, token) {
        try {
            return await apiClient.put("/doctor-department/" + id, data, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async Delete(id, token) {
        try {
            return await apiClient.delete("/doctor-department/" + id, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }

    async GetAllDoctorDepartment(token) {
        try {
            return await apiClient.get("/getAllDoctorDepartment", {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            return error;
        }
    }
}
